export default "__VITE_ASSET__ac06d1f6__"